import Tabs from './TabsClient';
import { Screen } from '../views/Screen';

Tabs.Screen = Screen;

export { Tabs };

export default Tabs;
